import {
    IPersonalPlanResponse,
    IStatisticPersonalPlanResponse,
    IWorkoutResponse,
} from 'api/components/PersonalPlan/types';
import { IUserPersonalisationResponse } from 'api/components/User/types';

import {
    GeneratePlanTypes,
    ISetLastPlanDayHatch,
    PersonalPlanState,
    WorkoutCompleteTypes,
} from 'store/personalPlan/types';

import { Action } from 'types/commonInterfaces';
import { IWorkoutExtended } from 'types/personalPlan';

import * as actionTypes from './actionTypes';

export const getCompletedPlanStatisticsRequest = (payload?: Action) => {
    return {
        type: actionTypes.GET_COMPLETED_PLAN_STATISTICS,
        payload,
    } as const;
};

export const getCompletedPlanStatisticsSuccess = (payload: IStatisticPersonalPlanResponse) => {
    return {
        type: actionTypes.GET_COMPLETED_PLAN_STATISTICS_SUCCESS,
        payload,
    } as const;
};

export const getWorkoutRequest = () => {
    return {
        type: actionTypes.GET_WORKOUT_REQUEST,
    } as const;
};

export const getWorkoutSuccess = (payload: IWorkoutResponse) => {
    return {
        type: actionTypes.GET_WORKOUT_SUCCESS,
        payload,
    } as const;
};

export const getWorkoutError = () => {
    return {
        type: actionTypes.GET_WORKOUT_ERROR,
    } as const;
};

export const getCurrentPlanRequest = (payload?: Action) => {
    return {
        type: actionTypes.GET_CURRENT_PLAN,
        payload,
    } as const;
};

export const getCurrentPlanSuccess = (
    payload: Pick<IPersonalPlanResponse, 'id' | 'current_day' | 'yoga_type' | 'plan_type' | 'instructor'> & {
        days: IWorkoutExtended[];
    }
) => {
    return {
        type: actionTypes.GET_CURRENT_PLAN_SUCCESS,
        payload,
    } as const;
};

export const getCurrentPlanError = () => {
    return {
        type: actionTypes.GET_CURRENT_PLAN_ERROR,
    } as const;
};

export const generatePlanRequest = (payload: GeneratePlanTypes = {}) => {
    return {
        type: actionTypes.GENERATE_PLAN,
        payload,
    } as const;
};

export const setCurrentPlanCompletion = (payload: PersonalPlanState['isCurrentPlanComplete']) => {
    return {
        type: actionTypes.SET_CURRENT_PLAN_COMPLETION,
        payload,
    } as const;
};

export const workoutComplete = (payload: WorkoutCompleteTypes) => {
    return {
        type: actionTypes.COMPLETE_WORKOUT,
        payload,
    } as const;
};

export const setLastPlanDayHatch = (payload: ISetLastPlanDayHatch) => {
    return {
        type: actionTypes.SET_LAST_PLAN_DAY_HATCH,
        payload,
    } as const;
};

export const setCompletePlanModalVisibility = (payload: boolean) => {
    return {
        type: actionTypes.SET_COMPLETE_PLAN_MODAL_VISIBILITY,
        payload,
    } as const;
};

export const resetWorkout = () => {
    return {
        type: actionTypes.RESET_WORKOUT,
    } as const;
};

export const setPlanPersonalisationData = (payload: Omit<IUserPersonalisationResponse, 'level' | 'problem_zones'>) => {
    return {
        type: actionTypes.SET_PLAN_PERSONALIZATION_DATA,
        payload,
    } as const;
};

export const selectWorkoutDay = (payload: number | undefined) => {
    return {
        type: actionTypes.SELECT_WORKOUT_DAY,
        payload,
    } as const;
};

export const resetSelectedWorkoutDay = () => {
    return {
        type: actionTypes.RESET_SELECTED_WORKOUT_DAY,
    } as const;
};

export const finalizeSetupRequest = () => {
    return {
        type: actionTypes.FINALIZE_SETUP_REQUEST,
    } as const;
};

export const finalizeSetupFinished = () => {
    return {
        type: actionTypes.FINALIZE_SETUP_FINISHED,
    } as const;
};
